<template>
  <span v-if="maxHr" class="text-small ml-1 label-hr-max"
    >{{ $t('sessionsInfo.heartRate') }}<sub>max</sub> = {{ maxHr }} {{ $t('unit.bpm') }}</span
  >
</template>

<script>
import { patientMaxHR } from '@/mixins/patient-max-hr'

export default {
  name: 'PatientMaxHr',
  mixins: [patientMaxHR],
  props: {
    patient: {
      type: Object,
      required: true
    }
  }
}
</script>
